import { Route } from "react-router-dom";
import ServiceProviderHomepage from "../../screens/service_provider/ServiceProviderHomepage";
import ServiceProviderProfile from "../../screens/service_provider/ServiceProviderProfile";
import AdditionalDetails from "../../screens/service_provider/AdditionalDetails";

export const serviceProviderRoutes = [
  <Route
    key="service-provider-home"
    path="/"
    element={<ServiceProviderHomepage />}
  />,

  <Route
    key="service-provider-profile"
    path="/service-provider/profile"
    element={<ServiceProviderProfile />}
  />,
  <Route
    key="service-provider-additional-details"
    path="/service-provider/additional-details"
    element={<AdditionalDetails />}
  />,
];
